<template>
  <b-list-group-item>
    <b-row>
      <b-col :cols="cols || 6" class="text-pod">{{ metric }}:</b-col>
      <b-col><slot>{{ value }}</slot></b-col>
    </b-row>
  </b-list-group-item>
</template>

<script>
export default {
  props: ['metric', 'value', 'cols']
}
</script>
